import { makeObservable } from "mobx";
import { BaseSyncModelStore } from "@/store/sync/BaseSyncModelStore";
import { SyncModelKind } from "@/store/sync/types";
import { AppSubStoreArgs } from "@/store/types";
import { SpaceAccountCalendarConnectionModelData } from "@/store/calendar/space-account-calendar-connection/types";
import { SpaceAccountCalendarConnectionObservable } from "@/store/calendar/space-account-calendar-connection/SpaceAccountCalendarConnectionObservable";
import { SyncUpdateValue } from "@/store/sync/types";

export class AppStoreSpaceAccountCalendarConnectionStore extends BaseSyncModelStore<
  SpaceAccountCalendarConnectionObservable,
  SpaceAccountCalendarConnectionModelData
> {
  constructor(injectedDeps: AppSubStoreArgs) {
    super({ modelKind: SyncModelKind.SpaceAccountCalendarConnection, ...injectedDeps });
    makeObservable(this, {
      createSyncModel: false,
    });
  }

  createSyncModel(
    data: SyncUpdateValue<SpaceAccountCalendarConnectionModelData>
  ): SpaceAccountCalendarConnectionObservable {
    return new SpaceAccountCalendarConnectionObservable({
      id: data.model_id,
      data,
      store: this.store,
    });
  }
}
